import React from "react";
import TrinsicStart from "../trinsic/TrinsicStart";
import MojeIdLogo from "../../../assets/mojeid-logo.png";
import {
  IconShieldCheck,
  IconLock,
  IconUserCheck,
  IconFingerprint,
} from "@tabler/icons-react";
import useLocale from "../../../hooks/useLocale";

const MojeIdStart = () => {
  const locale = useLocale("mojeid");

  const mojeIdFeatures = [
    { icon: IconUserCheck, text: locale.features.feature1 },
    { icon: IconLock, text: locale.features.feature2 },
    { icon: IconShieldCheck, text: locale.features.feature3 },
  ];

  return (
    <TrinsicStart
      providerName="MOJEID"
      providerDisplayName="mojeID"
      logo={MojeIdLogo}
      logoWidth={50}
      title={locale.title}
      TitleIcon={IconFingerprint}
      features={mojeIdFeatures}
      poweredByText={locale.poweredBy}
      getStartedText={locale.getStarted}
    />
  );
};

export default MojeIdStart;
